<template>
  <div
    style="
      width: 1962px;
      height: 1388px;
      background: url(/static/img/QyzsCert.jpg);
      margin: 0 auto;
      text-align: unset;
    "
    id="mainboy"
  >
    <div
      class="text"
      style="left: 0px;top: 356px;position: relative;width: 1962px;font-size: 75px;text-align: center;font-weight: bolder;line-height: 89px;height:178px;font-family: STZhongsong;"
    >
      <p>{{ cert.certname }}</p>
	  <p v-if="cert.certnametwo">{{ cert.certnametwo }}</p>
    </div>
	<div
      class="text"
      style="    left: 0px;top: 397px;position: relative;width: 1962px;font-size: 30px;    text-align: center;"
    >
      <p>标准号：{{ cert.code }}</p>
    </div>
    <div class="hengxian">

    </div>
	<div
      class="text"
      style="    left: 251px;
    top: 437px;
    position: relative;
    width: 1465px;
    font-size: 29px;
    letter-spacing: 0.5px;
    line-height: 50px;
    font-family: STZhongsong;"

    >
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据《标准化发展纲要》政策，开展标准第三方评估，有效实施企业标准自我声明公开和监督制度，经客观、科学公证评估，本次标准评定本企业为:
      </p>
    </div>
    <div
      class="text"
      style="left: 0px;top: 479px;position: relative;width: 1961px;color: rgb(229 0 20);text-align: center;font-size: 106px;font-weight: bolder;font-family: STZhongsong;"
    >
      <p>{{ cert.type=='cb'?'参编单位':"主编单位" }}</p>
    </div>
	<div
      class="text"
      style="left: 176px; top: 622px; position: relative; width: 520px;font-size: 23px; text-align: left;font-size: 23px;"
    >
      <p>单位名称：{{ cert.qiyename }}</p>
    </div>
    <div
      class="text"
      style="left: 176px; top: 637px; position: relative; width: 500px;"
    >
      <p>查询网址：www.cnbz.org.cn</p>
    </div>
	<div
      class="text"
      style="left: 176px; top: 654px; position: relative; width: 520px; text-align: left;"
    >
      <p>信用代码：{{ cert.socialcreditcode }}</p>
    </div>
    
	 <div
      class="text"
      style="left: 176px; top: 668px; position: relative; width: 500px;"
    >
      <p>标准发布日期：{{formatExcelData(cert.bzfbdate)}}</p>
    </div>
    <div
      class="text"
      style="left: 176px; top: 680px; position: relative; width: 500px;"
    >
      <p>标准实施日期：{{formatExcelData(cert.bzssdate)}}</p>
    </div>
    <div class="text" :style="`left: 778.9px;top: 582px;position: relative;width: 705px;text-align: left;`">
      <img src="/static/img/fazhan2.png">
      <img src="/static/img/querycode.png">
      <img src="/static/img/zhaobiaow.png">
      <p>
        
      </p>
    </div>
    <div
      class="text"
      style="left: 772px; top: 597px; position: relative; width: 500px;    font-size: 20px;"
    >
      <p>标准化发展纲要 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;官网扫码查询 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招投标网查询</p>
    </div>
    <div
      class="text"
      style="left: 1335px;top: 497px;
    position: relative;
    width: 500px;
    font-size: 21px;
    letter-spacing: 3px;
"
    >
      <p>中国招标投标网:camc.cecbid.org.cn</p>
    </div>
    <div
      class="text"
      style="left: 1335px;
    top: 509px;
    position: relative;
    width: 800px;
    font-size: 21px;
    letter-spacing: 3px;
    ">
      <p>评审机构注册号：110106034347515</p>
    </div>
  </div>
</template>

<script>

// import QRCode from "qrcodejs2";
// import VueQr from 'vue-qr'
export default {
  data() {
    return {
      cert: {level:""},
      global,
      company: "XXXXXXXXXXXXXXXX",
      socilacredit: "XXXXXXXXXXXXXXXXXX",
      smallflag: false,
      fontSize:48,
      codeUrl:""
    };
  },
  components: {},
  created(){
    this.cert = this.$route.query;
    // this.cert={
    //   certname:'林业有害生物防制服务/企业能力等级评审知道标准',
    //   qiyename:'北京卫士康有害生物防治有限公司',
    //   socialcreditcode:'91451323MA5OAXYXOG',
    //   cardid:'421022198712043919',
    //   danwei:'南京市有害生物防制协会',
    //   code:'O/ZC077-2022',
    //   type:"cd",
    //   bzfbdate:"2022-02-12",
    //   bzssdate:"2023-02-12",
    //   certcode:'O/ZC077-2022'
    // }
	let position = this.cert.certname.indexOf('/');
	if (position>-1) {
		this.cert.certnametwo = this.cert.certname.slice(position+1);
		this.cert.certname = this.cert.certname.slice(0,position);
	}
  },
  methods: {
   formatExcelData(value) {
    let dataStr = this.formatExcel(value);
    if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
        value = new Date(dataStr);
        if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
            value.setDate(value.getDate() + 1);
        value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
        -2
        )}月${("00" + value.getDate()).slice(-2)}日`;
        return value;
    } else {
        if (dataStr.indexOf("年") > -1) {
            var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
            ttDate = ttDate.replace(/[^0-9]/gm, "-");
            value = new Date(ttDate);
            value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
            -2
            )}月${("00" + value.getDate()).slice(-2)}日`;

            return value;
        } else {
            if (!isNaN(dataStr)) {
                var data = new Date(1900, 0, dataStr);
                value = data;
                value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
            -2
            )}月${("00" + value.getDate()).slice(-2)}日`;

                return value;
            } else {
                return dataStr;
            }
        }
    }
},
 formatExcel(value) {
    if (!value) {
        return "";
    } else {
        if (typeof value == "string") {
            return value.trim();
        } else {
            return value.toString().trim();
        }
    }
}
  },
  mounted() {
    
    // this.creatQrCode(this.cert.code, this.cert.name);
  },
};
</script>

<style scoped>
.positiontext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  font-weight: 900;
}
.leveltext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.text {
  text-align: left;
  font-size: 23px;
  /* font-family: STZhongsong; */
}
.companytext {
  text-align: center;
  font-size: 27px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companytextsmall {
  text-align: center;
  font-size: 18px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companyposit
{
  left: -3px; top: 60px; position: relative; width: 794px
}
.companypositsmall
{
  left: -3px; top: 81px; position: relative; width: 794px
}
.soltext {
  text-align: center;
  font-size: 18.5px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltextsmall {
  text-align: center;
  font-size: 20px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltpositsmall
{
  left: -1px; top: 62px; position: relative; width: 794
}
.soltposit{
  left: -1px; top: 33px; position: relative; width: 794
}
.text1 {
  text-align: center;
  font-size: 35px;
  font-family: STZhongsong;
}
.text2 {
  text-align: left;
  font-size: 20px;
  font-family: STZhongsong;
}
.qrcode {
  display: inline-block;
}
.qrcode /deep/ canvas img {
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}

.textchang{
text-align: center;
    font-size: 30px;
    font-family: STZhongsong;
    line-height: 62px;
}
.hengxian{
  left: 253px;
    top: 424px;
    position: relative;
    width: 1455px;
    border-bottom: solid #E61C37 3.5px;  
}
img{
  width: 125px;
    margin-right: 44px;
}
</style>
